import { FC } from 'react';
import style from './index.module.css';
import { useLogging } from '../../../hooks/common/useLogging'; 

const LoadingAddSubscriptionButton: FC = () => {
  return (
    <button className={style.addButton} disabled={true}>
      読み込み中...
    </button>
  )
}

const LoadingMypage: FC = () => {
  return (
    <div className={style.loading}>
      <div className={style.loadingSpinner}>
        <span className={style['timer-loader']}></span>
      </div>
      <p className={style.loadingText}>
       現在お届け情報の読み込み中です。<br/>
       少々お待ちください。
      </p>
    </div>
  );
}

export const InitialLoading: FC = () => {

  useLogging('InitialLoading');

  const isAddSubscriptionButton = Boolean(window.location.href.match(/\?path=\/subscription\/add/));

  return isAddSubscriptionButton 
    ? <LoadingAddSubscriptionButton/>
    : <LoadingMypage/>;
};
